module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Guardian Guerrillas")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#reunion"
    }
  }, [_vm._v("Reunion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#recruitment"
    }
  }, [_vm._v("Recruitment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#the-sni-a-bar"
    }
  }, [_vm._v("The Sni-A-Bar")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#delivering-the-mail"
    }
  }, [_vm._v("‘Delivering the Mail’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#pirates-of-the-missouri"
    }
  }, [_vm._v("‘Pirates of the Missouri’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#the-battle-of-the-ravines"
    }
  }, [_vm._v("The Battle of the Ravines")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#beating-buel"
    }
  }, [_vm._v("Beating Buel")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch014#the-swearing-in"
    }
  }, [_vm._v("The Swearing in")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch015#bloody-bill-and-brother-jim-join-our-band"
    }
  }, [_vm._v("‘Bloody Bill’ and Brother Jim Join Our Band")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch016#the-tale-of-the-private-and-two-lieutenants"
    }
  }, [_vm._v("The Tale of the Private and Two Lieutenants")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#remember-osceola",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remember Osceola")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#battle-of-the-big-hill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle of the ‘Big Hill’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#for-want-of-uniforms",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Want of Uniforms")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#do-not-attack-a-brick-building-with-pistols",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do Not Attack a Brick Building with Pistols")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#saving-shelby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saving Shelby")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#return-to-springfield",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to Springfield")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#the-colonel-returns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘Colonel’ Returns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#for-mrs.-mccoy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Mrs. McCoy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#ripe-for-the-pickin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Ripe for the Pickin”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#homecoming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homecoming")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#the-tale-of-riley-crawford",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tale of Riley Crawford")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#revenge-by-ambush",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revenge by Ambush")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#malfeasance-or-murder",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malfeasance or Murder?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#remember-the-murdered-women-of-kansas-city",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remember the Murdered Women of Kansas City!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#the-burnt-district",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘Burnt’ District")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#beating-blunt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beating Blunt")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#now-is-the-winter-of-our-discontent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Now Is the Winter of Our Discontent’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#return-to-missouri",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to Missouri")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#dingus-the-bushwhacker",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Dingus’ the Bushwhacker")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#the-most-scared-fight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Most Scared Fight")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#we-mustered-them-out",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We ‘Mustered’ Them Out")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#deaths-of-two-titans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deaths of Two Titans")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#the-last-ride-with-captain-clarke",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Ride with ‘Captain Clarke’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0